import { UseQueryOptions, UseQueryResult, useQuery } from '@tanstack/react-query';

import { z } from 'zod';

import {
  GetOrderDepreciationSettingsV2APIError,
  GetOrderDepreciationSettingsV2APIVariables,
  fetchGetOrderDepreciationSettingsV2API,
} from '../toolkitComponents.js';
import { queryKeyFn, useToolkitContext } from '../toolkitContext.js';
import { Registry } from './registry.js';

type Response = z.infer<typeof schema>;
const { schema } = Registry.getOrderDepreciationSettingsV2API;

export function useGetOrderDepreciationSettingsV2API(
  variables: GetOrderDepreciationSettingsV2APIVariables,
  opts?: UseQueryOptions<Response, GetOrderDepreciationSettingsV2APIError>,
): UseQueryResult<Response> {
  const { fetcherOptions } = useToolkitContext();

  return useQuery<Response, GetOrderDepreciationSettingsV2APIError>(
    queryKeyFn({
      path: '/api/v2/orders/{orderID}/depreciationSettingsV2',
      operationId: 'getOrderDepreciationSettingsV2API',
      variables,
    }),
    async () => {
      const res = await fetchGetOrderDepreciationSettingsV2API({ ...fetcherOptions, ...variables });
      return schema.parse(res);
    },
    opts,
  );
}
